import React, { PureComponent } from "react";

export default class FetchingTopicsList extends PureComponent {
  render() {
    return (
      <div id="new-community-topics-fetching" className="fetching-v2 grid-x">
        {[1, 2, 3, 4].map(el => (
          <div
            className="topic-fetching cell small-12 medium-6 large-3"
            key={`topic-fetching-${el}`}
          >
            <div className="topic-fetching-author fetching-color" />
            <div className="topic-fetching-content">
              <div className="article-fetching-title fetching-text-60 fetching-color" />
              <div className="article-fetching-title fetching-text-20 fetching-color" />
              <div className="article-fetching-title fetching-text-30 fetching-color" />

              <div className="article-fetching-title fetching-color" />
              <div className="article-fetching-title fetching-color" />
              <div className="article-fetching-title fetching-color last" />
              <div className="topic-fetching-comment">
                <div className="article-fetching-title fetching-text-40 fetching-color" />
                <div className="article-fetching-title fetching-text-40 fetching-color" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Fetching/FetchingTopicsList.js